<template>
  <div class="music">
    <MusicListControll v-show="isShowMusicList" class="musicControll"></MusicListControll>
    <MusicDetailControll v-show="isShowMusicDetail" ref="detailControl" class="musicControll" v-bind:musicData="musicData" v-bind:previousID="previousID" v-bind:nextID="nextID"></MusicDetailControll>
  </div>
</template>

<script>
import MusicListControll from "./controlls/music/MusicListControll";
import MusicDetailControll from "./controlls/music/MusicDetailControll";

var _musicDatas = require("../assets/data/MusicDatas.json");

export default {
  name: 'Music',
  props: ['id'],
  components: {
    MusicListControll, MusicDetailControll
  },
  computed:{
    isShowMusicList: function(){
      return true;
    },
    isShowMusicDetail: function(){
      return this.id != undefined;
    },
    musicData: function(){
      if(this.id != undefined){
        return _musicDatas.find(data => data.id == this.id);
      }
      else{
        return null;
      }
    },
    previousID: function(){
      if(this.id != undefined){
        var index = _musicDatas.findIndex(data => data.id == this.id);
        if(index != -1)
        if(index == 0){
          return _musicDatas[_musicDatas.length - 1].id;
        }
        else{
          return _musicDatas[index - 1].id;
        }
         else
          return null;
      }
      else{
        return null;
      }
    },
    nextID: function(){
      if(this.id != undefined){
        var index = _musicDatas.findIndex(data => data.id == this.id);
        if(index != -1)
        if(index + 1 == _musicDatas.length){
          return _musicDatas[0].id;
        }
        else{
          return _musicDatas[index + 1].id;
        }
        else
          return null;
      }
      else{
        return null;
      }
    }
  },
  beforeRouteEnter(to,from ,next){
    next(vm=>{
      if(vm.id != undefined && vm.musicData == undefined){
        vm.$router.push('/music');
      }
    });
  },
  beforeRouteLeave(to,from ,next){
    this.$refs.detailControl.stopMusic();
    next();
  }
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.music{
  background-image: url('../assets/cover_music.png');
}
</style>
